import React from 'react'
import './CustomerBanner.css'
const CustomerBanner = () => {
    return (
        <>
            <section className='Customer_banner_container'>
                <div className="Customer_banner_container_detail">
                </div>
            </section>
            <section className='Customer_banner_container_second'>
                <div className="Customer_banner_container_detail_second">
                </div>
            </section>
        </>
    )
}

export default CustomerBanner